import Page from '@/components/Page/Page';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import BenefitsOverviewPageContent from '@uikit/components/BenefitsOverviewPageContent/BenefitsOverviewPageContent';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import EnercityFooter from '@uikit/components/EnercityFooter/EnercityFooter';
import Layout from '@uikit/components/Layout/Layout';
import LegacyHeader from '@uikit/components/LegacyHeader/LegacyHeader.wrapper';
import { BenefitsOverviewPageProps } from './interfaces';

const BenefitsOverviewPage = (
  pageData: PageModel<BenefitsOverviewPageProps>
): JSX.Element => {
  const { props } = pageData;
  const meta = extractPageMetaFromRouteData(pageData);

  useInitialPageDataLayer();

  return (
    <Layout>
      <Page meta={meta}>
        <LegacyHeader actionType={ClickableAction.None} />
        <BenefitsOverviewPageContent
          headline={props.headline}
          subHeadline={props.subHeadline}
          categories={props.categories}
          dealsAvailableSoon={props.dealsAvailableSoon}
          footNote={props.footNote}
          faqItems={props.faqItems}
          image={props.image}
          stageVariant={props.stageVariant}
          vimeoUrl={props.vimeoUrl}
          showAppBanner={props.showAppBanner}
        />

        <BackToTopButton />

        <EnercityFooter />
      </Page>
    </Layout>
  );
};
export default BenefitsOverviewPage;
